export default {"src":"__ASTRO_ASSET_IMAGE__Cd0ge0cq__","width":213,"height":45,"format":"svg"}